import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { getConfig, isConfigLoaded } from "../config";

// Don't initialize i18n here - it will be initialized after config is loaded
i18n
  .use(HttpBackend) // Load translations from server
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next); // Bind to React

/**
 * Initialize i18n with the loaded configuration
 * This must be called AFTER loadConfig() completes
 */
export async function initializeI18n(): Promise<void> {
  if (!isConfigLoaded()) {
    throw new Error("Configuration must be loaded before initializing i18n");
  }

  const config = getConfig();

  await i18n.init({
    fallbackLng: "en",
    supportedLngs: ["en", "ar", "es", "fr"],
    debug: false, // Set to true to see i18n namespace loading in console

    // Return key if translation is missing (instead of empty string)
    returnNull: false,
    returnEmptyString: false,

    interpolation: {
      escapeValue: false, // React already escapes
    },

    backend: {
      // Use the API URL from loaded config for DB-based translations
      loadPath: (lng: string[], ns: string[]) => {
        return `${config.baseApiUrl}/api/v1/translations/${lng[0]}/${ns[0]}?t=${Date.now()}`;
      },
      requestOptions: {
        cache: "no-store",
      },
    },

    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "crsPortalLng",
    },

    // Default namespace - use crsportal prefix to avoid conflicts with Frontend translations
    defaultNS: "crsportal-common",
    ns: [
      "crsportal-common",
      "crsportal-auth",
      "crsportal-registration",
      "crsportal-dashboard",
      "crsportal-profile",
      "crsportal-submissions",
      "common",
    ],

    react: {
      useSuspense: true,
    },
  });

  console.log("✓ i18n initialized with API URL:", config.baseApiUrl);
}

export default i18n;
